export default __webpack_public_path__ + "static/Seznam-63160ade5483e8ff1a13cfd719849cdf.svg";